export default "__VITE_ASSET__XBALeBgw__"